import type {
  CommunityGroup,
  CommunityPerson,
  Conversation,
} from '../types/community'

export const people: CommunityPerson[] = [
  {
    id: 'CAMP-4KD91LZP',
    username: 'ifeoma.e',
    displayName: 'Ifeoma Eze',
    initials: 'IE',
    headline: 'Systems Engineering 400L · tutors engineering maths',
    programme: 'B.Sc. Systems Engineering',
    level: '400 level',
    university: 'University of Lagos',
    campus: 'Akoka',
    visibility: {
      programme: 'campus',
      housingArea: 'friends',
      careerProfile: 'public',
      contact: 'friends',
    },
    housingArea: 'Akoka, within 1.2km of campus',
    careerHeadline: 'Seeking a 2027 energy-sector internship',
    relationship: 'friend',
    following: true,
    followsYou: true,
    mutualFriends: 14,
    sharedGroupIds: ['grp-1', 'grp-3'],
    providerHandle: 'ifeoma.e',
    reputation: [
      { dimension: 'services', label: 'Services', score: 96 },
      { dimension: 'community', label: 'Community', score: 88 },
    ],
    identityVerified: true,
    lastActive: 'Active today',
  },
  {
    id: 'CAMP-7QW22MRT',
    username: 'danielu',
    displayName: 'Daniel Uzo',
    initials: 'DU',
    headline: 'Computer Science 300L · frontend developer',
    programme: 'B.Sc. Computer Science',
    level: '300 level',
    university: 'University of Lagos',
    campus: 'Akoka',
    visibility: {
      programme: 'public',
      housingArea: 'friends',
      careerProfile: 'public',
      contact: 'campus',
    },
    housingArea: 'Bariga',
    careerHeadline: 'Open to frontend internships and freelance builds',
    relationship: 'friend',
    following: true,
    followsYou: false,
    mutualFriends: 9,
    sharedGroupIds: ['grp-4'],
    providerHandle: 'danielu',
    reputation: [
      { dimension: 'services', label: 'Services', score: 91 },
      { dimension: 'housing', label: 'Housing', score: 74 },
    ],
    identityVerified: true,
    lastActive: 'Active 2 hours ago',
  },
  {
    id: 'CAMP-1XB50FEN',
    username: 'tolua',
    displayName: 'Tolu Adeleke',
    initials: 'TA',
    headline: 'Mechanical Engineering 400L · SESA vice-president',
    programme: 'B.Eng. Mechanical Engineering',
    level: '400 level',
    university: 'University of Lagos',
    campus: 'Akoka',
    visibility: {
      programme: 'campus',
      housingArea: 'campus',
      careerProfile: 'campus',
      contact: 'friends',
    },
    housingArea: 'Yaba',
    careerHeadline: 'Graduate trainee applications in progress',
    relationship: 'friend',
    following: false,
    followsYou: true,
    mutualFriends: 22,
    sharedGroupIds: ['grp-1', 'grp-2'],
    reputation: [
      { dimension: 'community', label: 'Community', score: 94 },
      { dimension: 'knowledge', label: 'Knowledge', score: 70 },
    ],
    identityVerified: true,
    lastActive: 'Active yesterday',
  },
  {
    id: 'CAMP-9PL73HKO',
    username: 'gracen',
    displayName: 'Grace Nnamdi',
    initials: 'GN',
    headline: 'Alumna 2024 · career coach for graduates',
    programme: 'B.Sc. Economics',
    level: 'Alumna, 2024',
    university: 'University of Lagos',
    campus: 'Akoka',
    visibility: {
      programme: 'public',
      housingArea: 'friends',
      careerProfile: 'public',
      contact: 'campus',
    },
    housingArea: 'Lekki',
    careerHeadline: 'Talent partner · mentors final-year students',
    relationship: 'none',
    following: true,
    followsYou: false,
    mutualFriends: 5,
    sharedGroupIds: ['grp-5'],
    providerHandle: 'gracen',
    reputation: [
      { dimension: 'services', label: 'Services', score: 93 },
      { dimension: 'community', label: 'Community', score: 81 },
    ],
    identityVerified: true,
    lastActive: 'Active today',
  },
  {
    id: 'CAMP-3ZR64SVA',
    username: 'chidin',
    displayName: 'Chidi Nwosu',
    initials: 'CN',
    headline: 'Systems Engineering 200L',
    programme: 'B.Sc. Systems Engineering',
    level: '200 level',
    university: 'University of Lagos',
    campus: 'Akoka',
    visibility: {
      programme: 'campus',
      housingArea: 'friends',
      careerProfile: 'friends',
      contact: 'friends',
    },
    housingArea: 'Akoka',
    careerHeadline: 'Not shared with you',
    relationship: 'requested',
    following: false,
    followsYou: false,
    mutualFriends: 3,
    sharedGroupIds: ['grp-1'],
    reputation: [{ dimension: 'community', label: 'Community', score: 62 }],
    identityVerified: true,
    lastActive: 'Active 3 days ago',
  },
  {
    id: 'CAMP-6MN18TYU',
    username: 'blessinga',
    displayName: 'Blessing Ade',
    initials: 'BA',
    headline: 'Chemical Engineering 300L · robotics club',
    programme: 'B.Eng. Chemical Engineering',
    level: '300 level',
    university: 'University of Lagos',
    campus: 'Akoka',
    visibility: {
      programme: 'public',
      housingArea: 'campus',
      careerProfile: 'campus',
      contact: 'friends',
    },
    housingArea: 'Shomolu',
    careerHeadline: 'Looking for process-engineering internships',
    relationship: 'none',
    following: false,
    followsYou: false,
    mutualFriends: 7,
    sharedGroupIds: ['grp-2', 'grp-4'],
    reputation: [{ dimension: 'community', label: 'Community', score: 70 }],
    identityVerified: false,
    lastActive: 'Active last week',
  },
]

export const groups: CommunityGroup[] = [
  {
    id: 'grp-1',
    name: 'SVG 401 — Operations Research II',
    kind: 'Course',
    members: 148,
    privacy: 'Open',
    description: 'Coursework questions, past papers and revision sessions for the current semester.',
    joined: true,
    moderatedBy: 'Course rep · @tolua',
    activity: '12 messages today',
  },
  {
    id: 'grp-2',
    name: 'UNILAG Robotics Club',
    kind: 'Club',
    members: 210,
    privacy: 'Request to join',
    description: 'Weekly build sessions and the national robotics competition team.',
    joined: false,
    moderatedBy: 'Club executive',
    activity: '4 messages this week',
  },
  {
    id: 'grp-3',
    name: 'Women in Engineering',
    kind: 'Association',
    members: 385,
    privacy: 'Open',
    description: 'Mentoring circles, industry talks and scholarship support.',
    joined: true,
    moderatedBy: 'Association executive',
    activity: '9 messages this week',
  },
  {
    id: 'grp-4',
    name: 'Cedarwood Residence — Block B',
    kind: 'Housing',
    members: 24,
    privacy: 'Invite only',
    description: 'Residents of Block B: shared bills, maintenance updates and house rules.',
    joined: true,
    moderatedBy: 'Property manager · Cedarwood Living',
    activity: '3 messages today',
  },
  {
    id: 'grp-5',
    name: 'Class of 2027 — graduate schemes',
    kind: 'Interest',
    members: 512,
    privacy: 'Open',
    description: 'Deadlines, referrals and interview notes for graduate programmes.',
    joined: false,
    moderatedBy: 'Careers unit',
    activity: '27 messages this week',
  },
]

export const conversations: Conversation[] = [
  {
    id: 'cv-1',
    withHandle: 'tokoro',
    withName: 'Tosin Okoro',
    initials: 'TO',
    kind: 'provider',
    context: { label: 'Order ORD-40128 · motivation letter review', to: '/marketplace' },
    unread: 2,
    lastAt: '18 min ago',
    messages: [
      {
        id: 'm-1',
        from: 'them',
        body: 'I have your draft and the TU Delft programme page. First pass will be with you tomorrow evening.',
        at: 'Yesterday, 20:14',
      },
      {
        id: 'm-2',
        from: 'me',
        body: 'Thank you. The deadline is 15 January, so there is room for a second round if needed.',
        at: 'Yesterday, 20:31',
      },
      {
        id: 'm-3',
        from: 'them',
        body: 'Noted. One question — do you want the research-track angle kept, or a broader industry framing?',
        at: '18 min ago',
      },
    ],
  },
  {
    id: 'cv-2',
    withHandle: 'ifeoma.e',
    withName: 'Ifeoma Eze',
    initials: 'IE',
    kind: 'person',
    unread: 0,
    lastAt: '2 hours ago',
    messages: [
      {
        id: 'm-4',
        from: 'them',
        body: 'Are you going to the SESA meeting on Tuesday? I can save you a seat.',
        at: '3 hours ago',
      },
      { id: 'm-5', from: 'me', body: 'Yes, I registered this morning.', at: '2 hours ago' },
    ],
  },
  {
    id: 'cv-3',
    withHandle: 'grp-4',
    withName: 'Cedarwood Residence — Block B',
    initials: 'CB',
    kind: 'group',
    context: { label: 'Shared internet split · August', to: '/money' },
    unread: 3,
    lastAt: '5 hours ago',
    messages: [
      {
        id: 'm-6',
        from: 'them',
        body: 'Reminder: the August internet split is open. Two shares are still outstanding.',
        at: '6 hours ago',
      },
      { id: 'm-7', from: 'me', body: 'Mine is settled — the receipt is in my ledger.', at: '5 hours ago' },
    ],
  },
  {
    id: 'cv-4',
    withHandle: 'cedarwood',
    withName: 'Cedarwood Living',
    initials: 'CL',
    kind: 'landlord',
    context: { label: 'Room B-204 · maintenance request', to: '/housing' },
    unread: 0,
    lastAt: 'Monday',
    messages: [
      {
        id: 'm-8',
        from: 'me',
        body: 'The shower pressure in B-204 dropped over the weekend.',
        at: 'Monday, 08:12',
      },
      {
        id: 'm-9',
        from: 'them',
        body: 'Logged as MNT-2214. A plumber is scheduled for Thursday morning.',
        at: 'Monday, 09:40',
      },
    ],
  },
]

export function personByHandle(handle: string) {
  return people.find((person) => person.username === handle)
}
